<div class="backdrop" aria-hidden="true" (click)="closed.emit()" (keydown.escape)="closed.emit()"></div>

<aside class="drawer" [attr.aria-label]="(company() ? 'companies.edit' : 'companies.add') | translate">
  <header class="drawer-header">
    <h2>{{ (company() ? 'companies.edit' : 'companies.add') | translate }}</h2>
    <lib-button color="none" textColor="muted" icon="close" [ariaLabel]="'form.cancel' | translate" (click)="closed.emit()">
    </lib-button>
  </header>

  @if (loading() && !company()) {
    <app-spinner></app-spinner>
  } @else {
    <section class="identity">
      <div class="logo-field">
        <app-company-logo [name]="name" [logo]="logo" [size]="72"></app-company-logo>
        
        <app-file-input class="logo-input" [accept]="'image/*'" [noPreview]="true" [height]="72" (change)="onLogoSelected($event)">
        </app-file-input>
        @if (logo) {
          <lib-button color="none" textColor="danger" icon="delete" [text]="'companies.remove_logo' | translate"
            (click)="onLogoDeleted()">
          </lib-button>
        }
      </div>

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'companies.name' | translate }}</mat-label>
        <input matInput [(ngModel)]="name" maxlength="120" required (keydown.enter)="save()" />
      </mat-form-field>

      @if (error()) {
        <div class="save-error" role="alert">
          <mat-icon>error</mat-icon>
          <span>{{ error() | translate }}</span>
        </div>
      }

      <div class="actions">
        <lib-button [text]="(company() ? 'form.save' : 'companies.create') | translate" icon="check" [loading]="saving()"
          [disabled]="saving() || !name.trim()" (click)="save()">
        </lib-button>
      </div>
    </section>

    @if (company(); as company) {
      <section class="members">
        <h3>
          <mat-icon>folder</mat-icon>
          {{ 'companies.projects' | translate }}
          <span class="count">{{ company.projectsCount }}</span>
        </h3>

        @if (company.allProjects) {
          <p class="implicit">{{ 'companies.all_projects' | translate }}</p>
        } @else {
          <app-member-search placeholder="companies.attach_project" [search]="searchProjects" [excludeIds]="projectIds()"
            (picked)="attach('projects', $event)">
          </app-member-search>
          <ul class="member-list">
            @for (project of company.projects; track project.id) {
              <li>
                <mat-icon class="member-icon">folder_open</mat-icon>
                <span class="member-name">{{ project.name }}</span>

                <lib-button color="none" textColor="muted" icon="close" size="small" [tooltip]="'companies.detach' | translate"
                  (click)="detach('projects', project.id, project.name)">
                </lib-button>
              </li>
            } @empty {
              <li class="empty">{{ 'companies.no_projects' | translate }}</li>
            }
          </ul>
        }
      </section>

      <section class="members">
        <h3>
          <mat-icon>group</mat-icon>
          {{ 'companies.users' | translate }}
          <span class="count">{{ company.usersCount }}</span>
        </h3>

        @if (company.allProjects) {
          <p class="implicit">{{ 'companies.all_users' | translate }}</p>
        } @else {
          <app-member-search placeholder="companies.attach_user" [search]="searchUsers" [excludeIds]="userIds()"
            (picked)="attach('users', $event)">
          </app-member-search>
          <ul class="member-list">
            @for (user of company.users; track user.id) {
              <li>
                <app-user-avatar [avatarUrl]="user.avatar" [firstName]="user.firstName" [lastName]="user.lastName" [size]="28">
                </app-user-avatar>

                <span class="member-name">
                  {{ user.firstName }} {{ user.lastName }}
                  <small>{{ user.email }}</small>
                </span>
                
                <lib-button color="none" textColor="muted" icon="close" size="small" [tooltip]="'companies.detach' | translate"
                  (click)="detach('users', user.id, user.firstName + ' ' + user.lastName)">
                </lib-button>
              </li>
            } @empty {
              <li class="empty">{{ 'companies.no_users' | translate }}</li>
            }
          </ul>
        }
      </section>
    }
  }
</aside>
